// extracted by mini-css-extract-plugin
export var spinnerWrapper = "spinner-module--spinnerWrapper--31bed";